/* import __COLOCATED_TEMPLATE__ from './square-logo.hbs'; */
import SvgIcon from '@square/glass-ui/components/svg/svg-icon';
export default SvgIcon.extend({
  width: 48,
  height: 48,
  viewBox: '0 0 48 48'
});